import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Framework } from '@flint/framework';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


const useRowStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableRow: {
    fontSize: "17px",
    fontFamily: "Nunito Sans",
    fontStyle: "normal",
    lineHeight: "30px",
    color: "#000000",
  },
  colOrange: {
    color: "#DD7153",
  },
  collapsedSectionOpen: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(12.5),
  },
  collapsedSectionClose: {
    padding: 0,
  },
  curPointer: {
    cursor: "pointer",
  }
}));

const handleEditUser = (id) => {
  Framework.redirect(`/edit-user/${id}`);
}
const Row = (props) => {
  const row = props.row;
  const classes = useRowStyles();
  const [open, setOpen] = React.useState(false);


  return (
    <React.Fragment>
      <TableRow className={classes.root} hover>
        <TableCell>
        {row.startDate && <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>}
        </TableCell>
        <TableCell align="center" className={classes.tableRow}>{row.name}</TableCell>
        <TableCell align="center" className={classes.tableRow}>{row.status}</TableCell>
        <TableCell align="center" className={classes.tableRow}>{row.email}</TableCell>
        {/* <TableCell align="center" className={classes.tableRow}>{row.startDate}</TableCell>
          <TableCell align="center" className={classes.tableRow}>{row.endDate}</TableCell> */}
        <TableCell align="center" className={classes.tableRow}>{String(row.isAdmin)}</TableCell>
        <TableCell align="center" className={`${classes.tableRow} ${classes.curPointer}`}>
          <IconButton aria-label="edit" onClick={() => handleEditUser(row.email)}>
            <EditIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
      {row.startDate && <TableCell className={open ? classes.collapsedSectionOpen : classes.collapsedSectionClose} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid container>
              <Grid item xs={12} sm={6} container direction="row" justify="center">
                <Typography variant="subtitle2">Start Date: </Typography>
                <Typography variant="subtitle2">
                  {row.startDate}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} container direction="row">
                <Typography variant="subtitle2">End Date: </Typography>
                <Typography variant="subtitle2">
                  {row.endDate}
                </Typography>
              </Grid>
            </Grid>
          </Collapse>
        </TableCell>}
      </TableRow>
    </React.Fragment>
  );
}

export default Row;